// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2g7mY","dragIcon":"Choice_dragIcon__34Flz","left":"Choice_left__HVaBN","input":"Choice_input__1IY-z"};